<template>
  <div style="margin-left: 20">
    <div class="container">
      <div class="row">
        <table>
          <!--<tr>
			<td>
				<img src="./../resource/mstar_dbrs_logo.png" width="350" height="100" >
			</td>
		</tr>-->
          <tr>
            <td>
              <h2
                style="margin-top: 10px; margin-left: 15px; margin-bottom: 10px"
              >
                Mumbai Task Level Feedback Form
              </h2>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <form id="form_id" @submit.prevent="processForm">
      <div class="container">
        <table class="table-horizontal" width="50%" height="20">
          <tbody>
            <tr>
              <td><strong>Date</strong></td>
              <td>
                <input
                  class="us"
                  type="text"
                  v-model="feeddate"
                  readonly="true"
                  required
                  style="width: 273px"
                />
              </td>
            </tr>
            <tr>
              <td><strong>Group Name</strong></td>
              <td>
                <input
                  class="us"
                  type="text"
                  v-model="group"
                  readonly="true"
                  required
                  style="width: 273px"
                />
              </td>
            </tr>
            <tr>
              <td><strong>Deal/Company Name</strong></td>
              <td>
                <input
                  class="us"
                  type="text"
                  size="29"
                  readonly="true"
                  v-model="companyname"
                  required
                />
              </td>
            </tr>
            <tr>
              <td><strong>Function Supported</strong></td>
              <td>
                <input
                  class="us"
                  type="text"
                  size="29"
                  readonly="true"
                  v-model="functionSupported"
                  required
                />
              </td>
            </tr>
            <tr>
              <td><strong>Tasks Performed</strong></td>
              <td>
                <div id="divTaskPerformed">
                  <td>
                    <input
                      class="us"
                      type="text"
                      readonly="true"
                      v-model="task_performed"
                      size="29"
                      required
                    />
                  </td>
                </div>
              </td>
            </tr>
            <tr>
              <td><strong>Primary Analyst Email ID</strong></td>
              <td>
                <input
                  class="us"
                  type="text"
                  readonly="true"
                  v-model="usanalystid"
                  size="29"
                  required
                />
              </td>
            </tr>
            <tr>
              <td><strong>Mumbai Analyst Email ID</strong></td>
              <td>
                <input
                  class="us"
                  type="text"
                  readonly="true"
                  v-model="mumbaianalystid"
                  size="29"
                  required
                />
              </td>
            </tr>
            <tr
              v-if="
                group === 'EMEA RMBS/ABS' && task_performed === 'Par Report'
              "
              id="Par_Due_Date"
            >
              <td><strong>Par Due Date</strong></td>
              <td>
                <input
                  class="us"
                  type="text"
                  readonly="true"
                  v-model="Par_due_date"
                  style="width: 273px"
                />
              </td>
            </tr>
            <tr id="Comment">
              <td><strong>Comment</strong></td>
              <td>
                <textarea
                  class="us"
                  v-model="comment"
                  name="comment"
                  readonly
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="CRS !== 1" class="container">
        <div class="row">
          <div class="col-md-8">
            <label
              ><b
                ><u>
                  <h4>Evaluation Criteria:</h4>
                </u></b
              ></label
            >
            <table
              id="evaluationCriteria"
              style="
                border-collapse: collapse;
                border: 1px solid black;
                width: 100%;
                border: solid;
                border-width: 1px;
              "
            >
              <tbody>
                <tr>
                  <td>
                    <div class="wrapper">
                      <div class="grid-header">
                        <div class="header-item"></div>
                        <div
                          class="header-itemtime"
                          style="
                            padding-left: 30px !important;
                            width: 535px !important;
                          "
                        >
                          Not Met
                        </div>
                        <div class="header-itemtime">Met</div>
                      </div>
                      <div class="grid-row">
                        <div class="flex-item">Timeliness</div>
                        <label
                          class="flex-itemtime"
                          style="
                            padding-left: 40px !important;
                            width: 535px !important;
                          "
                        >
                          <input
                            :disabled="isnotActive"
                            type="radio"
                            value="Not Met"
                            v-model="Timeliness"
                          />
                          <span></span>
                        </label>
                        <label class="flex-itemtime">
                          <input
                            :disabled="isnotActive"
                            type="radio"
                            value="Met"
                            v-model="Timeliness"
                            checked="checked"
                          />
                          <span></span>
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="wrapper">
                      <div
                        v-if="
                          group === 'EMEA RMBS/ABS' &&
                          functionSupported === 'Surveillance'
                        "
                        class="grid-header"
                      >
                        <div class="header-item"></div>
                        <div class="header-item"></div>
                        <div class="header-item">Needed Rework</div>
                        <div class="header-item"></div>
                        <div class="header-item">Some Adjustments Needed</div>
                        <div class="header-item"></div>
                        <div class="header-item">Highly Satisfied</div>
                      </div>
                      <div
                        v-if="
                          group === 'EMEA RMBS/ABS' &&
                          functionSupported !== 'Surveillance'
                        "
                        class="grid-header"
                      >
                        <div class="header-item"></div>
                        <div class="header-item"></div>
                        <div class="header-item">Needed Rework</div>
                        <div class="header-item"></div>
                        <div class="header-item">Satisfied</div>
                        <div class="header-item"></div>
                        <div class="header-item">Highly Satisfied</div>
                      </div>
                      <div
                        v-if="
                          (group === 'CMBS' &&
                          (functionSupported === 'Surveillance' &&
                          (task_performed === 'Deal Support_SA' ||
                            task_performed === 'Deal Support_DA')) ||
                          (functionSupported === 'New Issuance' &&
                            task_performed === 'Working Tape & Model Run'))
							//||(group === 'FUNDS')
                        "
                        class="grid-header"
                      >
                        <div class="header-item"></div>
                        <div class="header-item"></div>
                        <div class="header-item">Needed Rework</div>
                        <div class="header-item">Below Expectations</div>
                        <div class="header-item">Satisfied</div>
                        <div class="header-item">Within Expectations</div>
                        <div class="header-item">Highly Satisfied</div>
                      </div>
                      <div v-else-if="group === 'CMBS'" class="grid-header">
                        <div class="header-item"></div>
                        <div class="header-item"></div>
                        <div
                          class="header-item"
                          v-if="task_performed === 'Presale'"
                        >
                          Major Edits
                        </div>
                        <div
                          class="header-item"
                          v-else-if="
                            (functionSupported === 'Research' &&
                              task_performed === 'Any') ||
                            (functionSupported === 'Surveillance' &&
                              (task_performed === 'Deal Surveillance' ||
                                task_performed === 'BP Updates Write-up' ||
                                task_performed === 'CRE CLO RAC requests'))
                          "
                        >
                          Needed Rework
                        </div>
                        <div class="header-item" v-else>Major Changes</div>
                        <div class="header-item"></div>

                        <div
                          class="header-item"
                          v-if="task_performed === 'Presale'"
                        >
                          Minor Edits
                        </div>
                        <div
                          class="header-item"
                          v-else-if="
                            (functionSupported === 'Research' &&
                              task_performed === 'Any') ||
                            (functionSupported === 'Surveillance' &&
                              (task_performed === 'Deal Surveillance' ||
                                task_performed === 'BP Updates Write-up' ||
                                task_performed === 'CRE CLO RAC requests'))
                          "
                        >
                          Satisfied
                        </div>
                        <div class="header-item" v-else>Minor Changes</div>
                        <div class="header-item"></div>
                        <div
                          class="header-item"
                          v-if="task_performed === 'Presale'"
                        >
                          No Edits
                        </div>
                        <div
                          class="header-item"
                          v-else-if="
                            (functionSupported === 'Research' &&
                              task_performed === 'Any') ||
                            (functionSupported === 'Surveillance' &&
                              (task_performed === 'Deal Surveillance' ||
                                task_performed === 'BP Updates Write-up' ||
                                task_performed === 'CRE CLO RAC requests'))
                          "
                        >
                          Highly Satisfied
                        </div>
                        <div class="header-item" v-else>No Changes</div>
                      </div>
                      <div v-if="group === 'ABS'" class="grid-header">
                        <div class="header-item"></div>
                        <div class="header-item"></div>
                        <div class="header-item">Not Satisfactory</div>
                        <div class="header-item"></div>
                        <div class="header-item">Satisfactory</div>
                        <div class="header-item"></div>
                        <div class="header-item">Highly Satisfactory</div>
                      </div>
                      <div
                        v-if="
                          group !== 'EMEA RMBS/ABS' &&
                          group !== 'CMBS' &&
                          group !== 'ABS'
                          //&& group !== 'FUNDS'
                        "
                        class="grid-header"
                      >
                        <div class="header-item"></div>
                        <div class="header-item"></div>
                        <div class="header-item">Needed Rework</div>
                        <div class="header-item"></div>
                        <div class="header-item">Satisfied</div>
                        <div class="header-item"></div>
                        <div class="header-item">Highly Satisfied</div>
                      </div>
                      <div class="grid-header">
                        <div class="header-item"></div>
                        <div class="header-item">NA</div>
                        <div class="header-item">1</div>
                        <div class="header-item">2</div>
                        <div class="header-item">3</div>
                        <div class="header-item">4</div>
                        <div class="header-item">5</div>
                      </div>
                      <div class="grid-row">
                        <div class="flex-item">Overall Quality</div>
                        <label class="flex-item">
                          <input
                            v-if="!FeedbackQuesAns"
                            type="radio"
                            value="NA"
                            v-model="feed"
                            v-on:click="update('NA')"
                          />
                          <span></span>
                          <input
                            v-if="FeedbackQuesAns"
                            :disabled="isnotActive"
                            type="radio"
                            value="NA"
                            v-model="feed"
                          />
                          <span>{{}}</span>
                        </label>
                        <label class="flex-item">
                          <input
                            v-if="!FeedbackQuesAns"
                            type="radio"
                            value="1"
                            v-model="feed"
                            v-on:click="update(1)"
                          />
                          <span></span>
                          <input
                            v-if="FeedbackQuesAns"
                            :disabled="isnotActive"
                            type="radio"
                            value="1"
                            v-model="feed"
                          />
                          <span></span>
                        </label>
                        <label class="flex-item">
                          <input
                            v-if="!FeedbackQuesAns"
                            type="radio"
                            value="2"
                            v-model="feed"
                            v-on:click="update(2)"
                          />
                          <span></span>
                          <input
                            v-if="FeedbackQuesAns"
                            :disabled="isnotActive"
                            type="radio"
                            value="2"
                            v-model="feed"
                          />
                          <span></span>
                        </label>
                        <label class="flex-item">
                          <input
                            v-if="!FeedbackQuesAns"
                            type="radio"
                            value="3"
                            v-model="feed"
                            v-on:click="update(3)"
                          />
                          <span></span>
                          <input
                            v-if="FeedbackQuesAns"
                            :disabled="isnotActive"
                            type="radio"
                            value="3"
                            v-model="feed"
                          />
                          <span></span>
                        </label>
                        <label class="flex-item">
                          <input
                            v-if="!FeedbackQuesAns"
                            type="radio"
                            value="4"
                            v-model="feed"
                            v-on:click="update(4)"
                          />
                          <span></span>
                          <input
                            v-if="FeedbackQuesAns"
                            :disabled="isnotActive"
                            type="radio"
                            value="4"
                            v-model="feed"
                          />
                          <span></span>
                        </label>
                        <label class="flex-item">
                          <input
                            v-if="!FeedbackQuesAns"
                            type="radio"
                            value="5"
                            v-model="feed"
                            v-on:click="update(5)"
                          /><span></span>
                          <input
                            v-if="FeedbackQuesAns"
                            :disabled="isnotActive"
                            type="radio"
                            value="5"
                            v-model="feed"
                          />
                          <span></span>
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr
                  v-for="item in questAnswMapkey"
                  v-bind:key="item.id"
                  v-bind:id="item"
                >
                  <td
                    v-if="item != 'Any other comments' && item != 'Timeliness'"
                  >
                    <div class="wrapper">
                      <div v-if="orderDecider === 0">
                        <div
                          class="grid-header"
                          v-if="questAnswMap[item].length === 3"
                        >
                          <div class="header-item"></div>
                          <div class="header-item"></div>
                          <div class="header-item">
                            {{ questAnswMap[item][2] }}
                          </div>
                          <div class="header-item"></div>
                          <div class="header-item">
                            {{ questAnswMap[item][1] }}
                          </div>
                          <div class="header-item"></div>
                          <div class="header-item">
                            {{ questAnswMap[item][0] }}
                          </div>
                        </div>
                        <div
                          class="grid-header"
                          v-else-if="questAnswMap[item].length === 2"
                        >
                          <div class="header-item"></div>
                          <div class="header-item"></div>
                          <div class="header-item">
                            {{ questAnswMap[item][1] }}
                          </div>
                          <div class="header-item"></div>
                          <div class="header-item"></div>
                          <div class="header-item"></div>
                          <div class="header-item">
                            {{ questAnswMap[item][0] }}
                          </div>
                        </div>
                      </div>
                      <div v-if="orderDecider === 1">
                        <div
                          class="grid-header"
                          v-if="questAnswMap[item].length === 3"
                        >
                          <div class="header-item"></div>
                          <div class="header-item"></div>
                          <div class="header-item">
                            {{ questAnswMap[item][0] }}
                          </div>
                          <div class="header-item"></div>
                          <div class="header-item">
                            {{ questAnswMap[item][1] }}
                          </div>
                          <div class="header-item"></div>
                          <div class="header-item">
                            {{ questAnswMap[item][2] }}
                          </div>
                        </div>
                        <div
                          class="grid-header"
                          v-else-if="questAnswMap[item].length === 2"
                        >
                          <div class="header-item"></div>
                          <div class="header-item"></div>
                          <div class="header-item">
                            {{ questAnswMap[item][0] }}
                          </div>
                          <div class="header-item"></div>
                          <div class="header-item"></div>
                          <div class="header-item"></div>
                          <div class="header-item">
                            {{ questAnswMap[item][1] }}
                          </div>
                        </div>
                      </div>
                      <div class="grid-header">
                        <div class="header-item"></div>
                        <div class="header-item">NA</div>
                        <div class="header-item">1</div>
                        <div class="header-item">2</div>
                        <div class="header-item">3</div>
                        <div class="header-item">4</div>
                        <div class="header-item">5</div>
                      </div>
                      <div class="grid-row">
                        <div class="flex-item" v-if="group == 'RMBS'">
                          <div
                            v-if="item == 'Model Completeness'"
                            class="flex-item flex-container"
                          >
                            {{ item }}<br /><span class="flex-container"
                              >(Pool Run, Assumptions, Model Update)</span
                            >
                          </div>
                          <div
                            v-if="item == 'Data accuracy across deliverables'"
                            class="flex-item flex-container"
                          >
                            {{ item }}<br /><span class="flex-container"
                              >(Presale charts & graphs, SRC, R&W, RADAR fields,
                              Rent Data, Expense data, Cap Rate, interest rates
                              and HPI)</span
                            >
                          </div>
                          <div
                            v-if="item == 'Analytical Inputs'"
                            class="flex-item flex-container"
                          >
                            {{ item }}<br /><span class="flex-container"
                              >(Cashflows and sensitivities runs)</span
                            >
                          </div>
                        </div>

                        <div class="flex-item" v-if="group != 'RMBS'">
                          {{ item }}
                        </div>
                        <label class="flex-item">
                          <input
                            v-if="!FeedbackQuesAns"
                            type="radio"
                            value="NA"
                            v-model="dummy[item]"
                          />
                          <span></span>
                          <input
                            v-if="FeedbackQuesAns"
                            :disabled="isnotActive"
                            type="radio"
                            value="NA"
                            v-model="dummy[item][0]"
                          />
                          <span></span>
                        </label>
                        <label class="flex-item">
                          <input
                            v-if="!FeedbackQuesAns"
                            type="radio"
                            value="1"
                            v-model="dummy[item]"
                          />
                          <span></span>
                          <input
                            v-if="FeedbackQuesAns"
                            :disabled="isnotActive"
                            type="radio"
                            value="1"
                            v-model="dummy[item][0]"
                          />
                          <span></span>
                        </label>
                        <label class="flex-item">
                          <input
                            v-if="!FeedbackQuesAns"
                            type="radio"
                            value="2"
                            v-model="dummy[item]"
                          />
                          <span></span>
                          <input
                            v-if="FeedbackQuesAns"
                            :disabled="isnotActive"
                            type="radio"
                            value="2"
                            v-model="dummy[item][0]"
                          />
                          <span></span>
                        </label>
                        <label class="flex-item">
                          <input
                            v-if="!FeedbackQuesAns"
                            type="radio"
                            value="3"
                            v-model="dummy[item]"
                          />
                          <span></span>
                          <input
                            v-if="FeedbackQuesAns"
                            :disabled="isnotActive"
                            type="radio"
                            value="3"
                            v-model="dummy[item][0]"
                          />
                          <span></span>
                        </label>
                        <label class="flex-item">
                          <input
                            v-if="!FeedbackQuesAns"
                            type="radio"
                            value="4"
                            v-model="dummy[item]"
                          />
                          <span></span>
                          <input
                            v-if="FeedbackQuesAns"
                            :disabled="isnotActive"
                            type="radio"
                            value="4"
                            v-model="dummy[item][0]"
                          />
                          <span></span>
                        </label>
                        <label class="flex-item">
                          <input
                            v-if="!FeedbackQuesAns"
                            type="radio"
                            value="5"
                            v-model="dummy[item]"
                          /><span></span>
                          <input
                            v-if="FeedbackQuesAns"
                            :disabled="isnotActive"
                            type="radio"
                            value="5"
                            v-model="dummy[item][0]"
                          /><span></span>
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <div class="container">
                    <div class="row">
                      <td>
                        <div
                          class="col-3 flex-item"
                          style="width: 20% !important"
                        >
                          Comment
                        </div>
                      </td>
                      <td style="width: 500px">
                        <div class="grid-row">
                          <textarea
                            id="usComment"
                            style="width: 500px; margin-left: 100px"
                            v-model="usComment"
                            @change="getData"
                          >
                          </textarea>

                          <span v-show="Commentrequirement" style="color: red"
                            >Comment is required</span
                          >
                        </div>
                        <div id="commentdiv">
                          <div id="tooltip1" class="tooltip1">
                            <textarea
                              id="usComment"
                              style="width: 100%; height: 100%"
                              v-model="usComment"
                            >
                            </textarea>
                            <button
                              :disabled="isnotActive"
                              type="button"
                              v-on:click="closeComment"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                        <span
                          v-if="!FeedbackQuesAns"
                          v-on:click="expandComment"
                          style="width: 500px; margin-left: 100px; color: blue"
                          ><u>click here to expand comment box</u></span
                        >
                      </td>
                    </div>
                  </div>
                </tr>
                <br />
                <tr>
                  <div class="container">
                    <div class="row">
                      <td><strong>Attach file</strong></td>
                      <td style="padding-left: 100px">
                        <input
                          type="file"
                          id="files"
                          ref="files"
                          multiple
                          v-on:change="handleFilesUpload"
                        />
                        <div class="large-12 medium-12 small-12 cell">
                          <div
                            v-for="(file, key) in files"
                            class="file-listing"
                            v-bind:key="key.id"
                            v-bind:id="key"
                          >
                            {{ file.name }}
                            <span
                              class="remove-file"
                              v-on:click="removeFile(key)"
                              >Remove</span
                            >
                          </div>
                        </div>
                        <div class="large-12 medium-12 small-12 cell">
                          <button
                            :disabled="isnotActive"
                            v-on:click="addFiles()"
                          >
                            Add Files
                          </button>
                        </div>
                      </td>
                    </div>
                  </div>
                </tr>
                <br />
                <tr>
                  <td>
                    <button
                      style="width: 400px; margin-left: 150px"
                      type="submit"
                      :disabled="isnotActive"
                      v-on:click="submitForm"
                    >
                      Submit
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </form>
    <!--<div id="submit-loader" style="display: none;">
		<clip-loader :color="'#56A5EC'" :size="size"></clip-loader>
	</div>-->
  </div>
</template>

<script>
import axios from "axios";
//import ClipLoader from '../../node_modules/vue-spinner/src/ClipLoader.vue'

const S3_DIRECTORY = "us-feedback-files/";
export default {
  name: "us",
  props: {},
  //components : {ClipLoader},
  data() {
    return {
      files: [],
      isnotActive: false,
      Commentrequirement: false,
      horizontal: "",
      message: false,
      CRS: false,
      feed: "",
      usans: {},
      usComment: "",
      jsonresponse: {},
      feeddate: "",
      companyname: "",
      functionSupported: "",
      group: "",
      task_performed: "",
      usanalystid: "",
      mumbaianalystid: "",
      Par_due_date: "",
      comment: "",
      mumbai_analyst_comment: "",
      modelId: "",
      questAnswMap: [],
      questAnswMapkey: [],
      ans: [],
      dummy: {},
      rowCount: "",
      quesAns: "",
      Timeliness: "Met",
      orderDecider: 0,
      FeedbackQuesAns: {},
      FeedbackQuesAnsKeys: [],
    };
  },
  methods: {
    buildS3FileName(fileName) {
      const safeName = String(fileName || "attachment");
      const ext = (safeName.match(/\.[^./]+$/) || [""])[0];
      const base =
        safeName.slice(0, safeName.length - ext.length) || "attachment";
      return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}__${encodeURIComponent(base)}${ext}`;
    },
    getParameterByName(name, url = window.location.href) {
      name = name.replace(/[/[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    handleFilesUpload() {
      //this.file = this.$refs.file.files[0];
      let uploadedFiles = this.$refs.files.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        let fileObj = {};
        fileObj.name = uploadedFiles[i].name;
        fileObj.s3Name = this.buildS3FileName(uploadedFiles[i].name);
        fileObj.fileinstance = uploadedFiles[i];
        this.files.push(fileObj);
      }
      this.$refs.files.value = "";
    },
    addFiles() {
      this.$refs.files.click();
    },
    removeFile(key) {
      this.files.splice(key, 1);
    },
    validateForm() {
      if (this.usComment.length < 1) {
        if (this.feed < 3 || this.feed.length === 0) {
          this.Commentrequirement = true;
          return false;
        }
        const indextimeliness = this.questAnswMapkey.indexOf("Timeliness");
        const indexComment = this.questAnswMapkey.indexOf("Any other comments");
        let removeValFromIndex = [];
        removeValFromIndex.push(indextimeliness);
        removeValFromIndex.push(indexComment);
        for (var i = removeValFromIndex.length - 1; i >= 0; i--)
          this.questAnswMapkey.splice(removeValFromIndex[i], 1);

        for (i = 0; i < this.questAnswMapkey.length; i++) {
          if (
            this.dummy[this.questAnswMapkey[i]] < 3 ||
            this.dummy[this.questAnswMapkey[i]].length === 0
          ) {
            this.Commentrequirement = true;
            return false;
          }
        }

        this.Commentrequirement = false;
        return true;
      } else {
        this.Commentrequirement = false;
        if (!this.feed) {
          return false;
        }

        return true;
      }
    },
    update(para) {
      for (var a in JSON.stringify(this.questAnswMapkey)) {
        if (
          this.questAnswMapkey[a] !== "Any other comments" ||
          this.questAnswMapkey[a] !== "Timeliness"
        ) {
          this.dummy[this.questAnswMapkey[a]] = para;
        }
      }
      delete this.dummy["undefined"];
      delete this.dummy["Timeliness"];
      delete this.dummy["Any other comments"];
      this.dummy["feed"] = para;
      this.feed = para;
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    try() {
      alert("hello");
    },

    expandComment() {
      document.getElementById("tooltip1").style.transition =
        "opacity 0.5s ease";
      document.getElementById("tooltip1").style.visibility = "visible";
      document.getElementById("tooltip1").style.opacity = "1";
    },
    closeComment() {
      document.getElementById("tooltip1").style.transition =
        "opacity 0.5s ease";
      document.getElementById("tooltip1").style.visibility = "hidden";
      document.getElementById("tooltip1").style.opacity = "0";
    },
    getData() {
      Object.assign(this.usans, { "Any other comments": this.usComment });
    },
    async getPresignedURL(fileName, contentType) {
      const url =
        process.env.VUE_APP_RCA_LAMBDA +
        "presigned_url?" +
        new URLSearchParams({
          fileName: S3_DIRECTORY + fileName,
          fileType: contentType || "application/octet-stream",
        });
      const s3PresignedURL = fetch(url, {
        method: "get",
        credentials: "include",
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("failed to get Presigned URL");
          }
        })
        .catch((err) => console.error(`${err.message}`));
      return s3PresignedURL;
    },
    upload(s3UploadURL = "", file, file_type) {
      // using fetch here because AWS requires to set correct content-type
      const resolvedType = file_type || "application/octet-stream";
      const res = fetch(s3UploadURL, {
        method: "PUT",
        headers: { "Content-Type": resolvedType },
        body: file,
      })
        .then((res) => {
          if (res.ok) {
            //console.log(`files uploaded to S3 sucessfully`)
            return res;
          } else {
            throw new Error("failed to upload file to S3 bucket");
          }
        })
        .catch((err) => {
          console.error(`${err.message}`);
          alert(err.message);
          throw new Error(err.message);
        });
      return res;
    },
    async UploadfilesToS3(files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        const respdata = await this.getPresignedURL(
          file.s3Name,
          file.fileinstance.type,
        );
        const newFile_name = file.name;
        const newFile = new File([file.fileinstance], newFile_name, {
          type: file.fileinstance.type,
        });
        await this.upload(respdata, newFile, newFile.type);
      }
      return this.files;
    },
    async submitForm() {
      if (this.validateForm()) {
        let fileNames = [];
        this.isnotActive = true;
        if (this.files && this.files && this.files.length > 0) {
          console.log("init file upload");
          // upload files to s3
          await this.UploadfilesToS3(this.files);
        }

        for (let i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          fileNames.push(file.s3Name);
        }

        this.dummy["Timeliness"] = this.Timeliness;
        this.dummy["comment"] = this.usComment;
        const formData = {
          feeddate: this.feeddate,
          grpname: this.group,
          companyname: this.companyname,
          functionsupported: this.functionSupported,
          tasksperformed: this.task_performed,
          usanalystid: this.usanalystid,
          mumbaianalystid: this.mumbaianalystid,
          Par_due_date: this.Par_due_date,
          comment: this.comment,
          usans: this.usans,
          feed: this.dummy,
          files: fileNames,
        };
        console.log("in submit form");
        console.log("payload==>", formData);
        // document.getElementById('submit-loader').style.display = 'block';
        console.log("after spinner");
        axios
          .post(process.env.VUE_APP_BACKEND_API + "usfeedbackform", formData, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          })
          .then(
            (response) => {
              if (response.status === 200) {
                console.log("US feedback submitted");
                if (this.feed < 3 || this.Timeliness === "Not Met") {
                  console.log("RCA is required, preparing to send mail..");
                  const data = {
                    feeddate: this.feeddate,
                    grpname: this.group,
                    companyname: this.companyname,
                    functionsupported: this.functionSupported,
                    tasksperformed: this.task_performed,
                    usanalystid: this.usanalystid,
                    mumbaianalystid: this.mumbaianalystid,
                    par_due_date: this.Par_due_date,
                    us_comment: this.usComment,
                    mumbai_comment: this.mumbai_analyst_comment,
                    usans: JSON.stringify(this.usans), // onshore analyst comments
                    feed: this.feed == "NA" ? 0.0 : this.feed,
                    taskid: this.taskId,
                    modelid: this.modelId,
                    isTimelinessMet: this.Timeliness == "Met" ? true : false,
                  };

                  fetch(process.env.VUE_APP_RCA_LAMBDA + "rca/sendmail", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify(data),
                  })
                    .then((res) => {
                      //console.log("Checking response")
                      if (res.ok) {
                        //document.getElementById('submit-loader').style.display = 'none';
                        alert("successfully submitted form");
                      } else {
                        //document.getElementById('submit-loader').style.display = 'none';
                        throw new Error("failed to submit form");
                      }
                    })
                    .catch((err) => {
                      console.error(`${err.message}`);
                      alert(err.message);
                      throw new Error(err.message);
                    });
                } else {
                  //document.getElementById('submit-loader').style.display = 'none';
                  alert("successfully submitted form");
                }
              }

              //window.location.href = process.env.VUE_APP_UI ;
            },
            (error) => {
              if (error.response.status === 400) {
                alert("Response already recorded");
                this.$router.go();
                this.isnotActive = false;
              } else {
                alert("Some error in recording response");
                this.$router.go();
                this.isnotActive = false;
              }
            },
          );
      }
    },
  },
  async created() {
    const getUrl = new URL(process.env.VUE_APP_BACKEND_API + "usfeedbackform");
    getUrl.searchParams.append("feeddate", this.getParameterByName("feeddate"));
    getUrl.searchParams.append("grpname", this.getParameterByName("grpname"));
    getUrl.searchParams.append(
      "companyname",
      this.getParameterByName("companyname"),
    );
    getUrl.searchParams.append(
      "functionsupported",
      this.getParameterByName("functionsupported"),
    );
    getUrl.searchParams.append(
      "tasksperformed",
      this.getParameterByName("tasksperformed"),
    );
    getUrl.searchParams.append(
      "usanalystid",
      this.getParameterByName("usanalystid"),
    );
    getUrl.searchParams.append(
      "mumbaianalystid",
      this.getParameterByName("mumbaianalystid"),
    );
    getUrl.searchParams.append("comment", this.getParameterByName("comment"));
    const parDueDate =
      this.getParameterByName("Par_due_date") ||
      this.getParameterByName("par_due_date") ||
      "";
    if (parDueDate) {
      getUrl.searchParams.append("Par_due_date", parDueDate);
    }

    this.mumbai_analyst_comment = this.getParameterByName("comment");

    const response = await axios
      .get(getUrl)
      .then((response) => (this.jsonresponse = response))
      .catch((error) => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
      });
    this.jsonresponse = response.data;
    console.log("data from mumbai=" + JSON.stringify(this.jsonresponse));
    this.feeddate = this.jsonresponse.usfeedbackformmap.feeddate;
    this.companyname = this.jsonresponse.usfeedbackformmap.companyname;
    this.functionSupported =
      this.jsonresponse.usfeedbackformmap.functionsupported;
    this.group = this.jsonresponse.usfeedbackformmap.grpname;
    this.FeedbackQuesAns = this.jsonresponse.feedbackQuesAnsMap;
    if (this.FeedbackQuesAns) {
      this.FeedbackQuesAnsKeys = Object.keys(this.FeedbackQuesAns);
      this.feed = this.FeedbackQuesAns["OVERALL FEEDBACK"][0];
      this.usComment = this.FeedbackQuesAns["Any other comments"][0];
      for (let a of this.FeedbackQuesAnsKeys) {
        this.dummy[a] = this.FeedbackQuesAns[a];
      }
      console.log("dummy=", JSON.stringify(this.dummy));
      this.isnotActive = true;
      document.getElementById("usComment").readOnly = true;
      document.getElementById("evaluationCriteria").classList.add("grayout");
    }
    if (this.group === "CRS") {
      this.CRS = 1;
    } else {
      this.CRS = 0;
    }
    this.task_performed = this.jsonresponse.usfeedbackformmap.tasksperformed;
    this.usanalystid = this.jsonresponse.usfeedbackformmap.usanalystid;
    this.mumbaianalystid = this.jsonresponse.usfeedbackformmap.mumbaianalystid;
    this.modelId = this.jsonresponse.modelId;
    this.Par_due_date =
      parDueDate ||
      this.$route.query.Par_due_date ||
      this.$route.query.par_due_date ||
      this.jsonresponse.usfeedbackformmap.par_due_date ||
      "";
    this.comment = this.jsonresponse.usfeedbackformmap.comment;
    this.rowCount = this.jsonresponse.usfeedbackformmap.rowCount;
    this.questAnswMap = this.jsonresponse.questAnswMap;
    this.questAnswMapkey = Object.keys(this.jsonresponse.questAnswMap);

    this.ans = Object.values(this.jsonresponse.questAnswMap);
    this.taskId = this.jsonresponse.usfeedbackformmap.taskId;

    console.log(this.rowCount);

    if (
      this.group == "CORPORATE" ||
      this.group == "Credit Estimate" ||
      this.group == "EMEA RMBS/ABS"
    ) {
      this.orderDecider = 1;
    }
  },
};
</script>

<style scoped>
* {
  font-family:
    "Univers", HelveticaNeue, "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.tooltip1 {
  width: 90%;
  height: 200px;
  visibility: hidden;
  background-color: #fff;
  padding: 20px;
  -webkit-box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.5s ease;
  position: absolute;
  top: 65%;
  left: 5%;
  z-index: 1;
}

#commentdiv {
  cursor: pointer;
}

#commentdiv:hover .tooltip1 {
  visibility: visible;
  transition: opacity 0.5s ease;
  opacity: 1;
}

.wrapper {
  display: flex;
  flex-direction: column;
}
.grid-row {
  margin-bottom: 1em;
}

.grid-row,
.grid-header {
  display: flex;
  /*   flex: 1 0 auto; */
  /*   height: auto; */
}

.grid-header {
  align-items: flex-end;
}
.header-item {
  width: 100px;
  text-align: center;
  /*   border:1px solid transparent; */
}
.header-item:nth-child(1) {
  width: 180px;
}
.subtitle {
  font-size: 0.7em;
}
.flex-item:before {
  content: "";
  padding-top: 26%;
}
.flex-item {
  display: flex;
  /*   flex-basis:25%; */
  width: 100px;
  border-bottom: 1px solid #ccc;
  justify-content: center;
  align-items: center;
  /*   text-align:left; */
  font-size: 1em;
  font-weight: normal;
  color: #999;
}
.flex-item:nth-child(1) {
  border: none;
  font-size: 1.15em;
  color: #000;
  width: 180px;
  justify-content: left;
}

.flex-itemtime:before {
  content: "";
  padding-top: 26%;
}
.flex-itemtime {
  /*   flex-basis:25%; */
  border-bottom: 1px solid #ccc;
  justify-content: center;
  align-items: center;
  /*   text-align:left; */
  font-size: 1em;
  font-weight: normal;
  color: #999;
}
.flex-itemtime:nth-child(1) {
  border: none;
  font-size: 1.15em;
  color: #000;
  justify-content: left;
}
/* HTML5 Boilerplate accessible hidden styles */

[type="radio"],
[type="checkbox"] {
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/* One radio button per line */
label {
  /*display: block;*/
  cursor: pointer;
}

/* the basic, unchecked style */
[type="radio"] + span:before,
[type="checkbox"] + span:before {
  content: "";
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: -0.25em;
  border: 0.125em solid #fff;
  box-shadow: 0 0 0 0.15em #555;
  transition: 0.5s ease all;
}

[type="checkbox"] + span:before {
  margin-right: 0.75em;
}

/* the checked style using the :checked pseudo class */
[type="radio"]:checked + span:before,
[type="checkbox"]:checked + span:before {
  background: black;
}

/* never forget focus styling */
[type="radio"]:focus span:after {
  content: "\0020\2190";
  font-size: 1.5em;
  line-height: 1;
  vertical-align: -0.125em;
}

.us {
  width: 273px;
}

input[type="file"] {
  display: none;
}

span.remove-file {
  color: red;
  cursor: pointer;
  float: right;
}
.flex-container {
  display: flex;
  flex-direction: column;
}
.grayout {
  opacity: 0.6; /* Real browsers */
  filter: alpha(opacity = 60); /* MSIE */
}
</style>
